@import '@hevoio/hevo-ui-toolkit/styles/variables';
@import '@hevoio/hevo-ui-toolkit/styles/mixins';

.fireboltMessage {
  align-items: center;
  border: 0 !important;
  border-radius: 0 !important;
}

.errorMessage {
  border-color: $error-border;
}

.scrollComponent {
  overflow: auto;
  display: block;
  flex: 1;
}

.tableName {
  min-width: 280px;
}

.headerDropdown {
  min-width: 212px;
}

.warningContainer {
  background-color: $warning-faded-1;
  border-bottom: solid $border-width $warning-border;
}

.tableNameGroup {
  width: 280px;
}

.loadingOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: radial-gradient(ellipse closest-side, $surface-bg, $surface-bg, $surface-bg-60)
    no-repeat;
}

$arrow-height: 4px;

.arrow {
  z-index: 20;
  position: absolute;
  width: $arrow-height * 1.5;
  height: $arrow-height * 1.5;
  top: 46px;
  right: $spacer * 2;
  transform: rotate(-45deg);
  display: inline-block;
  border-right: $border-width solid $divider-color;
  border-top: $border-width solid $divider-color;
  margin-right: 1px;

  &::before {
    z-index: 10;
    position: absolute;
    top: -1px;
    right: -3px;
    content: '';
    width: 0px;
    height: 0px;
    border-left: $arrow-height solid transparent;
    border-right: $arrow-height solid transparent;
    border-bottom: $arrow-height solid $surface-bg;
    transform: rotate(45deg);
    pointer-events: none;
  }

  &::after {
    z-index: 30;
    position: absolute;
    top: -1px;
    right: -3px;
    content: '';
    width: 0px;
    height: 0px;
    border-left: $arrow-height solid transparent;
    border-right: $arrow-height solid transparent;
    border-bottom: $arrow-height solid $warning-faded-1;
    transform: rotate(45deg);
    pointer-events: none;
  }
}

.reorderRow {
  flex-direction: column;
  justify-content: center;
  .reorderRowIcon {
    font-size: $icon-size-base;
    opacity: 0.5;
    cursor: pointer;
    transition: all 200ms ease;
    &.disabled {
      opacity: 0.2;
      cursor: default;
    }
  }
  .moveRowDown {
    transform: translateY(-1px) rotate(180deg);
    &:not(.disabled):hover {
      transform: rotate(180deg) translateY(-1px);
    }
  }
  .moveRowUp {
    transform: translateY(1px);
    &:not(.disabled):hover {
      transform: translateY(-1px);
    }
  }
}

.arrowBase {
  z-index: 20;
  position: absolute;
  width: $spacer * 0.5;
  height: 1px;
  background-color: $surface-bg;
  right: $spacer * 2;
  top: 49px;

  &::before {
    z-index: 10;
    content: '';
    position: absolute;
    width: $spacer * 0.5;
    height: 1px;
    background-color: $warning-faded-1;
    pointer-events: none;
  }
}

.fieldAction {
  display: flex;
  align-items: center;
}

.flexTableCell {
  padding-top: $spacer * 0.75;
  padding-bottom: $spacer * 0.75;
  align-items: center;
}

.flexTableCell1 {
  padding-top: $spacer * 0.75;
  padding-bottom: $spacer * 0.75;
  align-items: center;

  & .hd-form-control {
    width: 100%;
  }

  & [data-type='source_field'] {
    flex-basis: 264px;
    flex-grow: 1;
    padding-left: $spacer * 0.5;
  }

  & [data-type='field_name'] {
    flex-basis: 220px;
    flex-grow: 1;
  }
  & [data-type='data_type'] {
    flex-basis: 216px;
    flex-grow: 1;
  }
}

.boxBody {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.withInfoTool {
  width: calc(100% - 319px);
  min-width: auto;
}

.flex-table__cell--short {
  min-width: 70px !important;
  flex-basis: 0 !important;
}

.tableTypeContent {
  max-width: 710px;

  .selectModeBox {
    max-height: 412px !important;
  }
}

.flexTableCellShort {
  min-width: 70px !important;
  flex-basis: 0 !important;
}

.flexTableRow:hover {
  .reorderRowIcon:not(.disabled) {
    opacity: 0.8;
  }
}

.fieldInfoToolContainer {
  max-width: 319px;
  overflow-y: auto;
}

.flexTableCellSourceField {
  flex-basis: 264px;
  flex-grow: 1;
  padding-left: $spacer * 0.5;
}

.flexTableCellFieldName {
  flex-basis: 220px;
  flex-grow: 1;
}

.flexTableCellDataType {
  flex-basis: 216px;
  flex-grow: 1;
}

.flexTableCellKey {
  flex-basis: 144px;
  flex-grow: 1;
  justify-content: center;
}

.sbHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: $spacer $spacer * 1.25;
  border-radius: $border-radius-md;
  border: 1px solid $divider-color;
  background: $surface-bg;
  margin-bottom: $spacer * 1.25;
  box-shadow: $shadow-default;
}

.moreActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 64px;
}

.flexTableCellReorder {
  min-width: auto;
  padding-right: 0;
  flex-basis: auto;
  flex-shrink: 0;
  width: $icon-size-base + $spacer * 1.25;
}

.flexTableCellMapField {
  min-width: auto;
  padding-right: 0;
  flex-basis: auto;
  flex-shrink: 0;
  width: $icon-size-base + $spacer * 1.25;
}

.createTableBtn {
  @include spinning-animation('hd-icon', 2s);
}

.boxTableContainer {
  box-sizing: content-box;
}
